.ADFWrapper
    position: relative
    width: 100%
    min-height: 0
    display: flex
    flex-direction: column
    .ADFName
        padding: 0 20px
        font-size: 18px
        font-weight: 700
    .ADFFeatures
        padding: 0 20px
        font-size: 14px
